__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "op-web-service";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "4.50.1", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(32)]).then(() => (() => (__webpack_require__(7032))))));
			register("@emotion/react", "11.11.1", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(751), __webpack_require__.e(416), __webpack_require__.e(550)]).then(() => (() => (__webpack_require__(3550))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(924), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(932))))));
			register("@mui/material", "5.14.20", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(751), __webpack_require__.e(771), __webpack_require__.e(114), __webpack_require__.e(416), __webpack_require__.e(468), __webpack_require__.e(439), __webpack_require__.e(924), __webpack_require__.e(968)]).then(() => (() => (__webpack_require__(771))))));
			register("@mui/styles", "5.14.20", () => (Promise.all([__webpack_require__.e(261), __webpack_require__.e(416), __webpack_require__.e(439), __webpack_require__.e(291)]).then(() => (() => (__webpack_require__(7261))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(697).then(() => (() => (__webpack_require__(5697))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(416), __webpack_require__.e(536)]).then(() => (() => (__webpack_require__(7536))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(767), __webpack_require__.e(416), __webpack_require__.e(468), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(8767))))));
			register("react-router-dom", "6.20.1", () => (Promise.all([__webpack_require__.e(539), __webpack_require__.e(818), __webpack_require__.e(416), __webpack_require__.e(468)]).then(() => (() => (__webpack_require__(9818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			initExternal(6239);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};